<template>
  <div class="topNaviBar">
    <div class="positionAbsolute t0 l0 w100 h100">

      <div class="positionRelative t0 l0 floatLeft naviItem touch hoverCursorPointer" @click="openCV()">
        <div class="positionAbsolute center t50 l50" v-html="$t('resume')"></div>
      </div>

      <div class="positionAbsolute t0 r0 naviItem touch hoverCursorPointer" @mouseup="switchLang()">
        <div class="positionAbsolute center t50 l50">
          <span v-show="this.language == 'EN'">繁</span>
          <span v-show="this.language == 'TC'">EN</span>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div class="absoluteCenter h100 w100 bgBlack" v-show="!isLoadingFinished"></div>
    </transition>
    

  </div>
</template>

<script>

import i18n from '@/language';
import { store } from '@/store'

export default {
  name: 'topNavi',
  data () {
    return {
      language : i18n.locale,
      totalNaviCount : 2,
      isLoadingFinished : store.state.isLoadingFinished,
    }
  },
  created(){

  },
  methods:{
    selectCategory(category){

    },

    contact(){
      console.log("contact");
      store.state.contactEvent = true;
    },

    openCV(){
      console.log("cv");
      window.open(' https://www.ivanho521.com/ivanho_CV.pdf','_blank');
      if(store.state.isGAEvent){
        gtag('event', 'openCV', {'event_callback': function() {}});
      }
    },

    switchLang(){
      if(this.language == "EN"){
        i18n.locale = "TC";
        localStorage.setItem('locale', "TC");
      }
      else{
        i18n.locale = "EN";
        localStorage.setItem('locale', "EN");
      }

    }

  },

  computed:{
    checkCurrentLanguage(){return i18n.locale;},
    checkSelectingIndex(){
      return store.state.selectingIndex;
    },
    checkIsLoadingFinished(){return store.state.isLoadingFinished},
  },
  watch:{
    checkCurrentLanguage(lang){this.language = lang;},
    checkSelectingIndex(flag){

    },
    checkIsLoadingFinished(flag){this.isLoadingFinished = flag},
  },
}
</script>

<style scoped>

.topNaviBar{
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  height: 10vh;
  background-color: #cce6f8;
  z-index: 999;
}

.naviItem{
  margin-left: 2em;
  width: 10vh;
  height: 10vh;
  font-size: 3vh;
  white-space: nowrap;
}



</style>



// WEBPACK FOOTER //
// src/components/topNavi.vue